//COLOR PALETTE
export const lightColor = "#e30414";
export const darkColor = "#2c2c2c";
export const lightGreyColor = "#e5e7eb";
export const darkGreyColor = "#6e7c90";

//CREDENTIALS
export const tmpUser: string = "user";
export const tmpPassword: string = "l4b101";

//NET JSON

//ZDM CREDENTIALS
export const workspaceId: string = "wks-7t4v6f2roav9";
export const apiKey: string =
  "LVIO0T9nJz.7ALTt-T8HXKTK1-IKcx1YPAymqnhGc4zzL0JYh659XFtMjZHaCSb$YGfVUn5bJ8t";

//MOCK
export const isDev =
  process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test";

//JSON
export const prepareParamsJson = (robby: any) => {
  if (Object.keys(robby).length === 0) {
    return {};
  } else {
    return { ...robby };
  }
};

export const prepareSensorJson = {
  CH1: {
    set: {
      type: "current_ac",
      exp: 1,
      input_number: 1,
      PGA: 2,
      SPS: 3000,
    },
    conversion: {
      type: "power",
      args: {
        n_coil: 1,
        n_samples: 80,
        ratio: 3000,
        voltage: 220,
        offset: 0,
        vref: 2.048,
      },
    },
  },
};

export const prepareConfigJson = {
  params: {
    wtd: 600000000,
    acq_freq: 500,
    fast_freq: 0,
    pub_freq: 1000,
    agent_timeout: 1500,
    store_period: 60,
    info_period: 1800,
    exc_period: 1800,
    dn_chunk_size: 32768,
    dn_wtd: 120000,
    offline_thr: 20,
    resolve_thr: 5,
  },
  exps: [
    {
      type: "ser",
      sw1: 0,
    },
  ],
};

export const prepareNetTestJson = {
  IFCS: [
    {
      ifc_name: "wifi",
      ifc_params: {
        ssid: "TNCAP495312",
        pwd: "Ga9cLGK63ANHZMn34tgG",
      },
    },
  ],
};
